export default "__VITE_ASSET__142f80b5__"